// import React, { useEffect, useState } from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import { base_url } from "Backend/api";

// const CartCopouns = () => {

//   const [coupons, setCoupons] = useState([]);

//   const fetchCoupons = async () => {
//     try {

//       const token = localStorage.getItem("token");

//       const res = await fetch(
//         `${base_url}/api/coupons?applies_to_type=all&is_active=true`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json"
//           }
//         }
//       );

//       const data = await res.json();

//       if (data.status) {

//         const formattedCoupons = data.data.map((item) => ({
//           id: item.id,
//           value: item.discount_value,
//           currency: item.discount_type === "percentage" ? "%" : "ل.س",
//           title: item.title,
//           description: item.description,
//           validUntil: new Date(item.ends_at).toLocaleDateString("ar-EG"),
//           minimum: item.minimum_order_amount,
//           code: item.code
//         }));

//         setCoupons(formattedCoupons);
//       }

//     } catch (error) {
//       console.error("Coupons error:", error);
//     }
//   };

//   useEffect(() => {
//     fetchCoupons();
//   }, []);

//   return (
//     <section id="coupons" className="w-full py-6 md:py-4 lg:py-6 scroll-mt-32 ">
//       <div className="max-w-7xl mx-auto">

//         <Swiper
//           modules={[Navigation]}
//           spaceBetween={10}
//           slidesPerView={1.2}
//           breakpoints={{
//             640: { slidesPerView: 1.5, spaceBetween: 10 },
//             768: { slidesPerView: 2.5, spaceBetween: 10 },
//             1024: { slidesPerView: 2.5, spaceBetween: 10 }
//           }}
//           dir="rtl"
//         >

//           {coupons.map((coupon) => (
//             <SwiperSlide key={coupon.id}>
//               <div className="coupon-ticket2 border rounded-xl font-[cairo] bg-[#f9fafb]">

//                 <div className="flex items-start justify-between gap-3">

//                   <div className="flex-1 min-w-0">

//                     <div className="flex items-baseline gap-1 mb-1">
//                       <span className="text-lg md:text-xl font-bold text-[#FF4500]">
//                         {coupon.value}
//                       </span>
//                       <span className="text-sm text-[#FF4500]">
//                         {coupon.currency}
//                       </span>
//                     </div>

//                     <h3 className="text-sm md:text-base line-clamp-1 font-bold text-foreground mb-1">
//                       {coupon.title}
//                     </h3>

//                     <p className="text-xs text-muted-foreground line-clamp-1">
//                       {coupon.description}
//                     </p>

//                   </div>

//                   <div className="text-[11px] md:text-xs text-muted-foreground mt-4 text-center">

//                     <div>
//                       ينتهى فى : {coupon.validUntil}
//                     </div>

//                     <div className='mb-2'>
//                       الحد الأدنى : {coupon.minimum}
//                     </div>

//                     <button className="bg-red-500 text-white px-2 rounded text-sm font-medium hover:bg-red-600">
//                       إضافة
//                     </button>

//                   </div>

//                 </div>

//               </div>
//             </SwiperSlide>
//           ))}

//         </Swiper>

//       </div>
//     </section>
//   );
// };

// export default CartCopouns;
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { base_url } from "Backend/api";
import toast from 'react-hot-toast';

const CartCopouns = ({ fetchCartAgain }) => {
  const [coupons, setCoupons] = useState([]);
  const [appliedCoupons, setAppliedCoupons] = useState([]);

  const token = localStorage.getItem("token");


  const fetchCoupons = async () => {
    try {
      const res = await fetch(`${base_url}/api/coupons`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });
      const data = await res.json();
      if (data.status) {
        const formattedCoupons = data.data.map(item => ({
          id: item.id,
          value: item.discount_value,
          currency: item.discount_type === "percentage" ? "%" : "ل.س",
          title: item.title,
          description: item.description,
          validUntil: new Date(item.ends_at).toLocaleDateString("ar-EG"),
          minimum: item.minimum_order_amount,
          code: item.code,
          type: item.applies_to_type
        }));
        setCoupons(formattedCoupons);

      }
    } catch (error) {
      console.error("Coupons error:", error);
    }
  };

  useEffect(() => { fetchCoupons(); }, []);
  // دالة لتطبيق الكوبون
  const applyCoupon = async (couponCode) => {
    try {
      const res = await fetch(`${base_url}/api/cart/apply-coupon`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ coupon_code: couponCode })
      });
      const data = await res.json();
      if (data.status) {
        setAppliedCoupons([...appliedCoupons, couponCode]);
        toast.success("تم تطبيق الكوبون بنجاح ");
        fetchCartAgain();
      } else {
        toast.error(data.message || "حدث خطأ عند تطبيق الكوبون ");
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      toast.error("حدث خطأ عند تطبيق الكوبون ");
    }
  };

  // دالة لحذف الكوبون
  const removeCoupon = async (couponCode) => {
    try {
      const res = await fetch(`${base_url}/api/cart/coupon/delete`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ coupon_code: couponCode })
      });
      const data = await res.json();
      if (data.status) {
        setAppliedCoupons(appliedCoupons.filter(code => code !== couponCode));
        toast.success("تم إلغاء الكوبون ");
        fetchCartAgain();
      } else {
        toast.error(data.message || "حدث خطأ عند إلغاء الكوبون ");
      }
    } catch (error) {
      console.error("Error removing coupon:", error);
      toast.error("حدث خطأ عند إلغاء الكوبون ");
    }
  };

  return (
    <>
      {coupons.length > 0 && (
        <section id="coupons" className="w-full py-1.5 md:py-3 lg:py-1.5 scroll-mt-32">
          <div className="max-w-7xl mx-auto">
            <Swiper
              modules={[Navigation]}
              spaceBetween={6}
              slidesPerView={2}
              breakpoints={{
                640: { slidesPerView: 1.5, spaceBetween: 10 },
                768: { slidesPerView: 2.5, spaceBetween: 10 },
                1024: { slidesPerView: 2.5, spaceBetween: 10 }
              }}
              dir="rtl"
            >
              {coupons.map(coupon => {
                const isApplied = appliedCoupons.includes(coupon.code);
                const isRestaurant = coupon.type === "restaurant";
                return (
                  <SwiperSlide key={coupon.id}>
                    <div className="coupon-ticket2 border rounded-xl cursor-pointer !px-2 !py-1.5 md:!px-2 md:!py-1.5 font-[cairo] bg-white">
                      <div className="flex items-start justify-between gap-2.5">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-baseline">
                            <span className={`text-lg md:text-xl font-bold ${isRestaurant ? "text-primary" : "text-green-500"}`}>
                              {coupon.value}
                            </span>

                            <span className={`text-sm ${isRestaurant ? "text-primary" : "text-green-500"}`}>
                              {coupon.currency}
                            </span>
                          </div>
                          <h3 className="text-[10px] line-clamp-1  md:text-base font-bold text-foreground  font-[cairo]">{coupon.title}</h3>
                          <p className="text-[8px] w-[90%] text-muted-foreground line-clamp-1 font-[cairo]">{coupon.description}</p>
                        </div>
                        <div className="text-[8px] md:text-xs text-muted-foreground mt-2 text-center">
                          <div>ينتهى فى : {coupon.validUntil}</div>
                          <div className="mb-1.5">الحد الأدنى : {coupon.minimum}</div>
                          <button
                            onClick={() => isApplied ? removeCoupon(coupon.code) : applyCoupon(coupon.code)}
                            className={`px-2 rounded text-[9px] font-medium text-white 
    ${isApplied
                                ? 'bg-gray-400'
                                : isRestaurant
                                  ? 'bg-primary hover:bg-red-600'
                                  : 'bg-green-500 hover:bg-green-600'
                              }`}
                          >
                            {isApplied ? 'إلغاء' : 'إضافة'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </section>
      )}
    </>
  );
};

export default CartCopouns;